module.exports = __webpack_public_path__ + "static/logo_sas_minimum_nb-2fe6513aec2e6318b1704c658f7d5e38.svg";